import { Button, Grid, Typography } from "@mui/material";
import { StyledTextField } from "../../../components/StyledComponent/StyledComponent";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { postRequest } from "../../../axios/axios";
import { saveEmail, handleIsEmailValid } from "../LoginSlice";
import { toast } from "react-toastify";
import { forgetMailPassSchema } from "../LoginSchema";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
const gridStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "1rem  2rem",
  width: "100%",
};
const flexDisplayStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const flexColumnStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};
const typoStyle = {
  marginTop: "5px",
  color: "rgba(0, 0, 0, 0.6)",
  textTransform: "none",
};
const ForgetMailPass = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  let defaultValue = {
    email: "",
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: defaultValue,
    validationSchema: forgetMailPassSchema,
    onSubmit: () => handleVerifyEmail(),
  });
  const { setFieldValue, values, handleBlur, touched, errors } = formik;
  const handleVerifyEmail = async () => {
    const toastId = toast.loading("Loading...");
    try {
      if (email?.length === 0) {
        return toast.error("Enter Your Email Address");
      }
      if (!formik.isValid) {
        return;
      }
      setIsDisabled(true);
      const reqBody = {
        email: `${email}`,
      };
      const res = await postRequest(`/api/forgot/password`, reqBody, "sdLogin");
      const { isSuccess, data, statusCode, error, message } = res?.data || {};
      if (isSuccess) {
        setIsDisabled(false);
        if (data?.isEmailExist && data?.isPasswordExist) {
          dispatch(handleIsEmailValid(true));
        }
        if (data?.isEmailExist && !data?.isPasswordExist) {
          navigate("/");
          dispatch(handleIsEmailValid(true));
        }
        if (isSuccess && statusCode === 200) {
          dispatch(handleIsEmailValid(true));
          return toast.success(data?.message);
        }
      } else if (!isSuccess) {
        if (statusCode === 400 && error === "User not found") {
          return toast.error(res?.data?.message);
        }
        toast.error(message);
      } else {
        toast.error(error);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsDisabled(false);
      toast.dismiss(toastId);
    }
  };
  const handleOnClickOnReset = () => {
    handleVerifyEmail();
  };
  const handleEmailChange = (e) => {
    const { value } = e.target;
    setFieldValue("email", value);
    dispatch(saveEmail(value));
    setEmail(value);
    setIsDisabled(false);
  };

  return (
    <>
      <Grid sx={gridStyle}>
        <form onSubmit={formik.handleSubmit}>
          <Grid item sx={flexDisplayStyle}>
            <Typography
              variant="h7"
              align="center"
              color="#040F3E"
              sx={{ margin: "0px 0px 10px 0px" }}
            >
              Forgot Password?
            </Typography>
          </Grid>

          <Grid item sx={flexColumnStyle}>
            <Typography align="center" variant="caption" sx={typoStyle}>
              Enter the email address associated
            </Typography>
            <Typography align="center" variant="caption" sx={typoStyle}>
              with your account
            </Typography>
          </Grid>

          <Grid xs={12} item sm={12} sx={{ margin: "20px 0px" }}>
            <StyledTextField
              size="small"
              fullWidth
              name="email"
              label="Your Email Address"
              value={values.email}
              onBlur={handleBlur}
              onChange={handleEmailChange}
              onClick={(e) => setEmail(e.target.value)}
              error={Boolean(touched.email && errors.email)}
            />
            {Boolean(touched.email && errors.email) && (
              <Typography variant="body2" color="error">
                {errors.email}
              </Typography>
            )}
          </Grid>

          <Grid item sx={{ textAlign: "center" }}>
            <Button
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={handleOnClickOnReset}
              disabled={isDisabled}
            >
              Reset Password
            </Button>
          </Grid>
        </form>
      </Grid>
    </>
  );
};
export default ForgetMailPass;
